import { render, staticRenderFns } from "./ConsultService.vue?vue&type=template&id=bd664452"
import script from "./ConsultService.vue?vue&type=script&lang=js"
export * from "./ConsultService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports